import { handleCall } from './handleResponse'

export const ticketsService = {
  getAllByOperatorId,
  addNote,
  getById,
  closeTicket,
  getAll,
  getAllOpenByVehicle,
  createTicket,
  getAllByDates,
}

function getAllByDates(since, until) {
  return handleCall(
    `/technicians/v1/Tickets/GetAll?${since}=since&until=${until}`,
    {
      method: 'GET',
      body: null,
    },
  )
  // var requestOptions = {
  //   method: "GET",
  //   headers: authHeader(),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Tickets/GetAll?${since}=since&until=${until}`,
  //   requestOptions
  // ).then(handleResponse);
}

function createTicket(body) {
  return handleCall(`/technicians/v1/Tickets/open`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
  // var requestOptions = {
  //   method: "POST",
  //   headers: authHeader(),
  //   body: JSON.stringify(body),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Tickets/open`,
  //   requestOptions
  // ).then(handleResponse);
}

function getAll() {
  return handleCall(`/technicians/v1/Tickets/getall`, {
    method: 'GET',
    body: null,
  })
  // var requestOptions = {
  //   method: "GET",
  //   headers: authHeader(),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Tickets/getall`,
  //   requestOptions
  // ).then(handleResponse);
}

function getAllOpenByVehicle(vehicleId) {
  const filter = `?VehicleId=${vehicleId}`
  return handleCall(`/technicians/v1/Tickets/GetOpenByVehicle${filter}`, {
    method: 'GET',
    body: null,
  })
  // var requestOptions = {
  //   method: "GET",
  //   headers: authHeader(),
  //   redirect: "follow",
  // };

  // const filter = `?VehicleId=${vehicleId}`;
  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Tickets/GetOpenByVehicle${filter}`,
  //   requestOptions
  // ).then(handleResponse);
}

function getAllByOperatorId(operatorId, since, until) {
  const sinceFilter = since ? `&since=${since}` : ''
  const untilFilter = until ? `&until=${until}` : ''
  const filter = `?SharingOperatorId=${operatorId}${sinceFilter}${untilFilter}`
  return handleCall(`/technicians/v1/Tickets/GetAllByOperator${filter}`, {
    method: 'GET',
    body: null,
  })
  // var requestOptions = {
  //   method: "GET",
  //   headers: authHeader(),
  //   redirect: "follow",
  // };
  // const sinceFilter = since ? `&since=${since}` : "";
  // const untilFilter = until ? `&until=${until}` : "";
  // const filter = `?SharingOperatorId=${operatorId}${sinceFilter}${untilFilter}`;

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Tickets/GetAllByOperator${filter}`,
  //   requestOptions
  // ).then(handleResponse);
}

function getById(id) {
  return handleCall(`/Technicians/v1/Tickets/${id}`, {
    method: 'GET',
    body: null,
  })
  // var requestOptions = {
  //   method: "GET",
  //   headers: authHeader(),
  //   redirect: "follow",
  // };
  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/Technicians/v1/Tickets/${id}`,
  //   requestOptions
  // ).then(handleResponse);
}
function closeTicket(body) {
  const ticketId = body.ticketId
  delete body.ticketId

  return handleCall(`/Technicians/v1/Tickets/${ticketId}/Close`, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
  // var requestOptions = {
  //   method: "PUT",
  //   headers: authHeader(),
  //   body: JSON.stringify(body),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/Technicians/v1/Tickets/${ticketId}/Close`,
  //   requestOptions
  // ).then(handleResponse);
}

function addNote(body) {
  const ticketId = body.ticketId
  delete body.ticketId

  return handleCall(`/Technicians/v1/Tickets/${ticketId}/AddNote`, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
  // var requestOptions = {
  //   method: "PUT",
  //   headers: authHeader(),
  //   body: JSON.stringify(body),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/Technicians/v1/Tickets/${ticketId}/AddNote`,
  //   requestOptions
  // ).then(handleResponse);
}
// function handleResponse(response) {
//     return response.text().then(text => {
//         if (response.status === 204 || response.status === 404) {
//             return []
//         }
//         const data = text && JSON.parse(text);
//         if (!response.ok) {
//             if (response.status === 401) {
//                 var refreshToken = loginService.getWithExpiry('refresh_token')
//                 loginService.refreshToken(refreshToken)
//                     .then(
//                         token => {
//                             loginService.setWithExpiry('token', token.access_token, token.expires_in);
//                         }
//                     )
//             }
//             const error = (data && data.message) || text;
//             return Promise.reject(error);
//         }

//         // check if the token is close to expire
//         var date = new Date();
//         var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
//             date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
//         var now = new Date(now_utc);
//         now.setMinutes(now.getMinutes() + 20)
//         var token_expire = new Date(loginService.getWithExpiry('token_dateExpiry'));
//         // if in 10 minutes expire, renew the token
//         if (now > token_expire) {
//             refreshToken = loginService.getWithExpiry('refresh_token')
//             loginService.refreshToken(refreshToken)
//                 .then(
//                     token => {
//                         loginService.setWithExpiry('token', token.access_token, token.expires_in);

//                     }
//                 )
//         }
//         return data;
//     });
// }
